import React, { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Unauthorized } from '../helpers/Unauthorized';
import { authContext } from '../Context/AuthContext';
import { cartContext } from '../Context/CartContext'; // Importá el contexto del carrito

export const Success = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { token } = useContext(authContext);
    const { emptyCart } = useContext(cartContext); // Extraé la función que vacía el carrito

    const country = process.env.REACT_APP_COUNTRY;

    useEffect(() => {
        emptyCart(); // Limpiar el carrito al montar
    }, []);

    if (!token) return <Unauthorized />

    const props = location;
    const compra = props.state.param.pedidoFinal;

    return (
        <div className='divSuccess'>
            <h1>Muchas gracias por su compra</h1>
            <h4>Su pedido <span>{compra.Numero}/01</span> ha sido creado y procesado con éxito</h4>
            <h4>El vendedor asignado se comunicará con Ud. a fin de coordinar la entrega de la compra</h4>
            
            {country === "ARG" && (
                <div style={{
                    backgroundColor: '#fee2e2',
                    border: '2px solid #dc2626',
                    borderRadius: '8px',
                    padding: '15px',
                    margin: '20px auto',
                    textAlign: 'center',
                    maxWidth: '600px'
                }}>
                    <p style={{
                        color: '#dc2626',
                        fontWeight: 'bold',
                        fontSize: '1.1rem',
                        margin: 0
                    }}>
                        ⚠️ IMPORTANTE: Recuerde que si usted seleccionó transferencia bancaria como medio de pago, no se aceptarán transferencias de terceros por cuestiones administrativas y de facturación.
                    </p>
                </div>
            )}
            
            <Button variant="secondary" onClick={() => navigate('/')}>Volver al inicio</Button>
        </div>
    )
}